import { render, staticRenderFns } from "./PermissionsGroupFilter.vue?vue&type=template&id=245d22f3"
import script from "./PermissionsGroupFilter.vue?vue&type=script&lang=js"
export * from "./PermissionsGroupFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports